import {
  type ModalV2Props,
  useModalStore,
} from '@teachino/shared-design-system';
import { $t } from '@teachino/shared-i18n';
import type { UpgradeSource } from '@teachino/shared-util';
import type { Component } from 'vue';
import UpgradePromptModal from './UpgradePromptModal.vue';

export type UpgradePromptModalProps = {
  source: UpgradeSource;
} & ModalV2Props<undefined>;

export type OpenUpgradePromptModalOptions = Pick<
  UpgradePromptModalProps,
  'source'
>;

export function openUpgradePromptModal(options: OpenUpgradePromptModalOptions) {
  return useModalStore().openModal<UpgradePromptModalProps, undefined>({
    title: $t('upgrade.feature_discovered.dialog_title'),
    size: 'md',
    component: UpgradePromptModal as Component,
    props: options,
  });
}
